import table from "assets/images/chart-images/table.png";

// Reports Portal (KGLOR-19): Number of responses to invitations + Reviewer type + Outcome of invitation - completed
const reviewerType = [
    { id: "#RIRTOIC-T01t", name: "table", chartImage: table, v2: "Column", disabled: false, description: " " },
    { id: "#RIRTOIC-T02t", name: "table", chartImage: table, v2: "Row", disabled: false, description: " " },
    { id: "#RIRTOIC-T20t", name: "table", chartImage: table, disabled: false, description: " " },
];

export default reviewerType;
